export default [{
  name: 'default'
}]
